import { bootstrapApplication } from '@angular/platform-browser';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { defineCustomElements } from '@scania/tegel/loader';
import { TegelModule } from '@scania/tegel-angular-17';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MsalModule, MsalInterceptor } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { msalInstance } from './app/shared/auth/msal-instance';
import { AppInitService, initializeApp } from './app/shared/services/app-init.service';
import { LoadingInterceptor } from './app/shared/interceptors/loading.interceptor';
import { environment } from './environments/environment';

defineCustomElements(window);

const protectedResourceMap = new Map<string, Array<string>>([
  [environment.apiUrl, [environment.apiScope]]
]);

msalInstance.initialize().then(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(routes),
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations(),
      importProvidersFrom(
        TegelModule,
        FormsModule,
        ReactiveFormsModule,
        MsalModule.forRoot(
          msalInstance,
          { interactionType: InteractionType.Redirect, authRequest: { scopes: [environment.apiScope] } },
          { interactionType: InteractionType.Redirect, protectedResourceMap }
        )
      ),
      { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
      { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService], multi: true },
    ],
  }).catch(console.error);
});
